const units = [
  { divisor: 1024 * 1024 * 1024, unit: 'Гб' },
  { divisor: 1024 * 1024, unit: 'Мб' },
  { divisor: 1024, unit: 'Кб' },
];

export default (value, rounded) => {
  // Get first matched element from unit list
  if (typeof value !== 'number' || value <= 0) { return; }
  const symbolsAfterComma = value.toString().split('.')[1] ? value.toString().split('.')[1].length : 0;
  const resultRounded = rounded ? rounded : symbolsAfterComma;
  const result = units.filter(
    (item) => value / item.divisor >= 1
  )[0];
  const resultNumber = value / result.divisor;
  return `${resultNumber.toFixed(resultRounded)} ${result.unit}`;
};
